import { Component, HostBinding, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, Sort } from '@angular/material/sort';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExportFilePopupComponent } from 'src/app/shared/components/export-file-popup/export-file-popup.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getRequestersOptions } from 'src/app/shared/helpers/Drop-down-options';
import {
  formatPcPortLocalAsUtc,
  formatPcUtcDateTime,
} from 'src/app/shared/helpers/pc-utc-datetime.util';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { VersioningconfirmationPopupComponent } from '../versioningconfirmation-popup/versioningconfirmation-popup.component';
import { GemininotesPopupComponent } from '../gemininotes-popup/gemininotes-popup.component';
import {
  PortConsumptionReportDownloadPopupComponent,
} from '../port-consumption-report-download-popup/port-consumption-report-download-popup.component';
import { PortDeleteConfirmPopupComponent } from '../port-delete-confirm-popup/port-delete-confirm-popup.component';

@Component({
  selector: 'app-port-my-request',
  templateUrl: './port-my-request.component.html',
  styleUrls: ['./port-my-request.component.scss'],
})
export class PortMyRequestComponent {
  retriveForm!: FormGroup;
  RetriveData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 0;
  paginatedData: any[] = [];
  elements: any;
  addRowdData: any[] = [];
  tableData: any[] = [];
  rowData: any = {};
  lastTableDataRowIndex: number = 0;
  requestersOptions: any;
  pdfData: any;
  isFilterOpen = false;
  userName: any;
  @ViewChild(MatSort) sort!: MatSort;
  shipNameSuggestions: any[] = [];
  errorMessage: any[] = [];
  pdfUrl: any;
  blobUrl: string | null = null;
  filteredData: any;
  username: any;
  clientOptions: string[] = [];
  selectedClients: string[] = [];
  /** Resolved once per session — the auth token does not change while mounted. */
  private adminUser = false;
  private merakiOperations = false;
  isLoading: boolean = true;
  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService,
    private sanitizer: DomSanitizer,
    private overlayService: OverlapService,
    private pRequestFormService: PortRequestFormServiceService,
    private dialog: MatDialog,
  ) {
    this.retriveForm = this.fb.group({
      createdAtFrom: [''],
      createdAtTo: [''],
      from: [''],
      to: [''],
      imoNumber: [''],
      shipName: [''],
    });
    this.requestersOptions = getRequestersOptions();
  }
  ngOnInit() {
    this.username = localStorage.getItem('username');
    this.adminUser = this.resolveAdminUser();
    this.merakiOperations = this.username === 'Meraki - Operations';
    this.loadData();
  }

  trackByRow(index: number, item: any): any {
    return item?.port_visit_id || item?.port_log_id || index;
  }

  formatUTCDate(dateValue: any): string {
    return formatPcUtcDateTime(dateValue);
  }

  formatPortLocalAsUTC(dateValue: any, portName?: string | string[] | null): string {
    const port = Array.isArray(portName) ? portName[0] : portName;
    return formatPcPortLocalAsUtc(dateValue, port);
  }
  capitalizeEveryWord(text: string): string {
    if (!text) {
      return '';
    }
    return text
      .split(' ')
      .map((word) => {
        if (word.length === 0) {
          return '';
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }
  loadData() {
    this.isLoading = true;
    this.username = localStorage.getItem('username');
    this.pRequestFormService.getMyRequests().subscribe((data) => {
      const clientFilters: { [key: string]: (item: any) => boolean } = {
        'Eiger Shipping': (item) =>
          item.client &&
          (item.client === 'Northwell' ||
            item.client.toLowerCase() === 'eiger'),
        'Zeronorth ZN': (item) =>
          item.client && item.client.toLowerCase() === 'zeronorth',
        'Elite Shipping': (item) =>
          item.client &&
          (item.client.toLowerCase() === 'elite tankship dmcc' ||
            item.client.toLowerCase() === 'elite'),
        'Bunge Shipping': (item) =>
          item.client && item.client.toLowerCase() === 'bunge',
        'Alcor Shipping': (item) =>
          item.client &&
          (item.client.toLowerCase() === 'alcor chartering dmcc' ||
            item.client.toLowerCase() === 'alcor chartering'),
        'EMZoil Shipping': (item) =>
          item.client &&
          (item.client.toLowerCase() === 'emz oil' ||
            item.client.toLowerCase() === 'emzoil fzco' ||
            item.client.toLowerCase().includes('emz')),
        'Ethiopian Shipping & Logistics': (item) => item.client.toLowerCase() === 'ethiopian shipping & logistics',
      };

      if (this.username === 'Meraki - Operations') {
        data = data;
      } else if (clientFilters[this.username]) {
        data = data.filter(clientFilters[this.username]);
      }
      const uniqueClients = [...new Set(data.map((item: any) => item.client))];

      this.clientOptions = uniqueClients.filter((client: any) => client) as string[];

      const currentYear = new Date().getFullYear();

      this.RetriveData = data
        .filter(
          (item: any) =>
            new Date(item.created_at).getFullYear() === currentYear,
        )
        .sort((a: any, b: any) => {
          return (
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
          );
        });
      this.filteredData = [...this.RetriveData];
      this.paginateData();
      this.isLoading = false;
    });
  }
  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length > 0) {
      this.shipNameSuggestions = this.RetriveData.filter((item: any) =>
        item.vessel_name.toLowerCase().startsWith(inputValue),
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  formatVesselName(name: string): string {
    if (!name) return '';

    return name
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim().length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  @HostBinding('class.pc-light') get pcLight(): boolean {
    return !this.isDarkMode();
  }
  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  paginateData() {

    const startIndex = this.currentPage * this.itemsPerPage;

    const data = this.filteredData?.length
      ? this.filteredData
      : this.RetriveData;

    this.paginatedData = data.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );

    this.decorateRows(this.paginatedData);
  }

  /**
   * Precomputes the strings the table renders.
   *
   * The template used to call formatters inside its bindings, so every cell was
   * re-formatted on every change-detection pass — including the timezone
   * conversions for EOSP/COSP, which are the most expensive work on the page.
   * Decorating the visible rows once makes the template pure property reads.
   * Fields are written onto the row itself so sorting, exports, the delete
   * payload and the insights dialog keep seeing the original object.
   */
  private decorateRows(rows: any[]): void {
    for (const row of rows) {
      if (!row || row._pcDisplayReady) {
        continue;
      }

      const vesselName = this.formatVesselName(row.vessel_name);
      row._pcVesselName = vesselName;
      row._pcVesselNameShort =
        row.vessel_name?.length > 10
          ? vesselName.slice(0, 10) + '...'
          : vesselName;

      const rawPort = row.resolved_port_name;
      // Mirrors the template's `resolved_port_name[0]` indexing exactly; the
      // API returns either a parts array or an empty string.
      const primaryPort = rawPort?.[0] || '';
      const portTitleCase = this.capitalizeEveryWord(primaryPort);
      row._pcPortUpper = primaryPort.toUpperCase();
      row._pcPortShort =
        primaryPort.length > 10
          ? portTitleCase.slice(0, 10) + '...'
          : portTitleCase;

      row._pcEosp = this.formatPortLocalAsUTC(row.eosp_datetime, rawPort);
      row._pcCosp = this.formatPortLocalAsUTC(row.cosp_datetime, rawPort);
      row._pcCargoOperation = this.formatVesselName(row.cargo_operation);
      row._pcUpdatedAt = this.formatUTCDate(row.updated_at);
      row._pcHasReport = this.hasReportDownload(row);

      row._pcDisplayReady = true;
    }
  }
  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, sort.active, isAsc);
    });
  }

  compare(a: any, b: any, sortActive: string, isAsc: boolean) {
    if (['cosp_datetime', 'eosp_datetime', 'updated_at'].includes(sortActive)) {
      const dateA = new Date(a[sortActive]);
      const dateB = new Date(b[sortActive]);

      if (dateA < dateB) {
        return isAsc ? -1 : 1;
      } else if (dateA > dateB) {
        return isAsc ? 1 : -1;
      }
      return 0;
    }

    if (a[sortActive] === null || a[sortActive] === undefined) return isAsc ? -1 : 1;
    if (b[sortActive] === null || b[sortActive] === undefined) return isAsc ? 1 : -1;

    const aNum = parseFloat(a[sortActive]);
    const bNum = parseFloat(b[sortActive]);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return (aNum < bNum ? -1 : 1) * (isAsc ? 1 : -1);
    }

    if (
      typeof a[sortActive] === 'string' &&
      typeof b[sortActive] === 'string'
    ) {
      return a[sortActive].localeCompare(b[sortActive]) * (isAsc ? 1 : -1);
    }

    return (a[sortActive] < b[sortActive] ? -1 : 1) * (isAsc ? 1 : -1);
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }
  clearClick() {
    this.retriveForm.reset();
    this.selectedClients = [];

    this.filteredData = [];

    this.currentPage = 0;

    this.paginateData();
  }
  // filterClick() {
  //   const { from, to, imoNumber, shipName, createdAtFrom, createdAtTo } =
  //     this.retriveForm.value;

  //   this.filteredData = this.RetriveData;

  //   // Filter by IMO Number
  //   if (imoNumber) {
  //     this.filteredData = this.filteredData.filter(
  //       (item: { vessel_imo: any }) =>
  //         (item.vessel_imo || '')
  //           .toString()
  //           .toLowerCase()
  //           .includes(imoNumber.toLowerCase()),
  //     );
  //   }

  //   // Filter by Ship Name
  //   if (shipName) {
  //     this.filteredData = this.filteredData.filter(
  //       (item: { vessel_name: any }) =>
  //         (item.vessel_name || '')
  //           .toLowerCase()
  //           .includes(shipName.toLowerCase()),
  //     );
  //   }

  //   // Filter by From Date (updatedAt range)
  //   if (from) {
  //     const fromDate = new Date(from);
  //     this.filteredData = this.filteredData.filter(
  //       (item: { created_at: string | number | Date }) => {
  //         const itemDate = new Date(item.created_at);
  //         return itemDate >= fromDate;
  //       },
  //     );
  //   }

  //   // Filter by To Date (updatedAt range)
  //   if (to) {
  //     const toDate = new Date(to);
  //     this.filteredData = this.filteredData.filter(
  //       (item: { created_at: string | number | Date }) => {
  //         const itemDate = new Date(item.created_at);
  //         return itemDate <= toDate;
  //       },
  //     );
  //   }

  //   // ✅ New filter for Created At From
  //   if (createdAtFrom) {
  //     const fromCreated = new Date(createdAtFrom);
  //     this.filteredData = this.filteredData.filter(
  //       (item: { created_at: string | number | Date }) => {
  //         const itemCreated = new Date(item.created_at);
  //         return itemCreated >= fromCreated;
  //       },
  //     );
  //   }

  //   // ✅ New filter for Created At To
  //   if (createdAtTo) {
  //     const toCreated = new Date(createdAtTo);
  //     this.filteredData = this.filteredData.filter(
  //       (item: { created_at: string | number | Date }) => {
  //         const itemCreated = new Date(item.created_at);
  //         return itemCreated <= toCreated;
  //       },
  //     );
  //   }

  //   this.currentPage = 0;
  //   this.paginatedData = this.filteredData.slice(0, this.itemsPerPage);
  // }
  filterClick() {

    const {
      from,
      to,
      imoNumber,
      shipName,
      createdAtFrom,
      createdAtTo,
    } = this.retriveForm.value;

    let data = [...this.RetriveData];

    if (this.selectedClients.length) {
      data = data.filter((item: any) =>
        this.selectedClients.some(
          (client) =>
            (item.client || '').toLowerCase() === client.trim().toLowerCase(),
        ),
      );
    }

    if (imoNumber) {
      data = data.filter((item: any) =>
        (item.vessel_imo || '')
          .toString()
          .toLowerCase()
          .includes(imoNumber.toLowerCase())
      );
    }

    if (shipName) {
      data = data.filter((item: any) =>
        (item.vessel_name || '')
          .toLowerCase()
          .includes(shipName.toLowerCase())
      );
    }

    if (from) {
      const fromDate = new Date(from);
      data = data.filter((item: any) =>
        new Date(item.cosp_datetime) >= fromDate
      );
    }

    if (to) {
      const toDate = new Date(to);
      data = data.filter((item: any) =>
        new Date(item.eosp_datetime) <= toDate
      );
    }

    if (createdAtFrom) {
      const fromDate = new Date(createdAtFrom);
      data = data.filter((item: any) =>
        new Date(item.updated_at) >= fromDate
      );
    }

    if (createdAtTo) {
      const toDate = new Date(createdAtTo);
      data = data.filter((item: any) =>
        new Date(item.updated_at) <= toDate
      );
    }

    this.filteredData = data;

    this.currentPage = 0;

    this.paginateData();
  }
  updatePagination() {
    this.paginateData();
  }
  padWithZero(value: number): string {
    return value < 10 ? '0' + value : '' + value;
  }

  hasReportDownload(row: any): boolean {
    return !!(this.getReportUrl(row, 'new') || this.getReportUrl(row, 'old'));
  }

  getReportUrl(row: any, type: 'old' | 'new'): string {
    const key =
      type === 'old'
        ? 'port_consumption_report_s3_url'
        : 'port_consumption_report_s3_url_new';
    const url = row?.[key];
    return typeof url === 'string' ? url.trim() : '';
  }

  openReportDownloadModal(row: any): void {
    if (!row) {
      return;
    }

    this.dialog.open(PortConsumptionReportDownloadPopupComponent, {
      width: '480px',
      maxWidth: 'calc(100vw - 48px)',
      maxHeight: 'calc(100vh - 48px)',
      panelClass: 'pc-report-download-dialog',
      backdropClass: 'pc-report-download-backdrop',
      autoFocus: false,
      hasBackdrop: true,
      data: {
        oldReportUrl: this.getReportUrl(row, 'old'),
        newReportUrl: this.getReportUrl(row, 'new'),
        vesselName: row?.vessel_name,
      },
    });
  }

  // callDownloadAPI(row: any, version: string) {

  //   let payload = {
  //     s3_url: row.port_consumption_report_s3_url,
  //     version: version   // 👈 important
  //   };

  //   this.pRequestFormService.getReport(payload)
  //     .subscribe((pdfBlob: Blob) => {
  //       this.overlayService.showPdf(pdfBlob);
  //     });

  // }
  isMerakiOperations(): boolean {
    return this.merakiOperations;
  }

  isAdminUser(): boolean {
    return this.adminUser;
  }

  /**
   * Decodes the auth token once. Previously this ran per row on every
   * change-detection pass, doing a base64 decode plus a JSON parse each time.
   */
  private resolveAdminUser(): boolean {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) return false;
      const parts = token.split('.');
      if (parts.length < 2) return false;
      const payload = JSON.parse(atob(parts[1]));
      const user = String(payload?.user || payload?.sub || '').toLowerCase().trim();
      return ['meraki_admin', 'mera_admin'].includes(user);
    } catch (err) {
      return false;
    }
  }

  confirmAndDelete(row: any, event?: Event): void {
    if (!row || !row.port_log_id) return;

    if (event) {
      event.stopPropagation();
      event.preventDefault();
      (event.currentTarget as HTMLElement)?.blur();
    }
    (document.activeElement as HTMLElement)?.blur();

    const arrDate = this.formatUTCDate(row.cosp_datetime);
    const depDate = this.formatUTCDate(row.eosp_datetime);
    const datesFormatted = (arrDate || depDate)
      ? `${depDate || '--'}  →  ${arrDate || '--'}`
      : undefined;

    const rawPort = row.resolved_port_name || row.port_name;
    const resolvedPort = Array.isArray(rawPort) ? (rawPort[0] || '') : (rawPort || '');

    const rawVessel = row.vessel_name;
    const resolvedVessel = Array.isArray(rawVessel) ? (rawVessel[0] || '') : (rawVessel || '');

    const dialogRef = this.dialog.open(PortDeleteConfirmPopupComponent, {
      width: '460px',
      maxWidth: '92vw',
      panelClass: 'pc-delete-confirm-dialog',
      backdropClass: 'pc-delete-confirm-backdrop',
      autoFocus: false,
      restoreFocus: false,
      data: {
        title: 'Delete Port Request',
        message: 'Are you sure you want to delete this port request? This will delete the request and all associated database records.',
        subMessage: 'This action will remove the record from your active views.',
        vesselName: resolvedVessel,
        vesselImo: row.vessel_imo,
        portName: resolvedPort,
        dates: datesFormatted,
        confirmText: 'Delete Request',
        cancelText: 'Cancel',
        isDanger: true,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const payload = { port_log_id: row.port_log_id, port_visit_id: row.port_visit_id };
        this.pRequestFormService.deleteMyRequestRow(payload).subscribe({
          next: (res: any) => {
            this.toastr.success('Request and associated database records deleted successfully');
            this.loadData();
          },
          error: (err: any) => {
            console.error('Delete failed', err);
            this.toastr.error('Could not delete request');
          },
        });
      }
    });
  }

  openInsights(row: any, event?: Event): void {
    if (!this.isMerakiOperations()) {
      return;
    }
    event?.stopPropagation();
    event?.preventDefault();

    if (!row) {
      this.toastr.warning('No vessel row selected for AI insights.');
      return;
    }

    try {
      this.dialog.open(GemininotesPopupComponent, {
        width: 'min(1180px, 96vw)',
        maxWidth: '96vw',
        maxHeight: '94vh',
        panelClass: 'ai-insights-dialog',
        backdropClass: 'ai-insights-backdrop',
        autoFocus: false,
        hasBackdrop: true,
        data: row,
      });
    } catch (err) {
      console.error('[AI Insights] failed to open dialog', err);
      this.toastr.error('Could not open AI Insights. Please refresh and try again.');
    }
  }
  exportClick() {
    const data = this.filteredData || this.RetriveData; // or use this.RetriveData if you want all data

    if (!data.length) {
      return;
    }

    const firstItem = data[0];
    const vesselName = firstItem.vessel_name || 'UnknownVessel';
    const imo = firstItem.vessel_imo || 'UnknownIMO';

    const csvHeader = 'S.No,Vessel Name,IMO Number,Cargo Name,Cargo Operation';

    const csvData = data
      .map((item: any, index: number) => {
        const cargoOperation = item.cargo_operation;
        return `${index + 1},${item.vessel_name},${item.vessel_imo},${item.cargo_name
          },${cargoOperation}`;
      })
      .join('\n');

    const csvContent = `${csvHeader}\n${csvData}`;
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `myrequest.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  // Example export logic functions
  exportSpeedConsumptionReport() {
    console.log('Exporting Speed and Consumption Report...');
    this.generateCsvFile('Speed_Consumption_Report.csv');
  }

  exportPortConsumptionReport() {
    console.log('Exporting Port Consumption Report...');
    this.generateCsvFile('Port_Consumption_Report.csv');
  }

  exportCombinedReport() {
    console.log('Exporting Combined Report...');
    this.generateCsvFile('Combined_Report.csv');
  }

  // Shared CSV generation logic
  generateCsvFile(fileName: string) {
    const data = this.filteredData || this.RetriveData;
    if (!data?.length) {
      return;
    }

    const csvHeader = 'S.No,Vessel Name,IMO Number,Cargo Name,Cargo Operation';
    const csvData = data
      .map((item: any, index: number) => {
        const cargoOperation = item.cargo_operation || '';
        return `${index + 1},${item.vessel_name},${item.vessel_imo},${item.cargo_name
          },${cargoOperation}`;
      })
      .join('\n');

    const csvContent = `${csvHeader}\n${csvData}`;
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
export declare class PageEvent {
  pageIndex: number;
  previousPageIndex?: number;
  pageSize: number;
  length: number;
}
